import axios from './BaseService';
import {
    startStrategy,
    stopStrategy,
    deleteStrategy,
} from './StrategiesService';
import {
    startAutomation,
    stopAutomation,
    deleteAutomation,
    getAutomation,
} from './AutomationsService';

const BOTS_URL = `${process.env.REACT_APP_API_URL}/bots/`;

export async function getBots(symbol = '', page = 1, type = '') {
    const params = new URLSearchParams({ page });
    if (symbol) params.set('symbol', symbol);
    if (type) params.set('type', type);
    const response = await axios.get(`${BOTS_URL}?${params.toString()}`);
    return response.data;
}

export async function getAllBots(symbol = '') {
    const params = new URLSearchParams({ all: 'true' });
    if (symbol) params.set('symbol', symbol);
    const response = await axios.get(`${BOTS_URL}?${params.toString()}`);
    return response.data.rows || [];
}

export async function startBot(bot) {
    if (bot.sourceType === 'strategy') {
        return startStrategy(bot.sourceId);
    }
    return startAutomation(bot.sourceId);
}

export async function stopBot(bot) {
    if (bot.sourceType === 'strategy') {
        return stopStrategy(bot.sourceId);
    }
    return stopAutomation(bot.sourceId);
}

export async function deleteBot(bot) {
    if (bot.sourceType === 'strategy') {
        return deleteStrategy(bot.sourceId);
    }
    return deleteAutomation(bot.sourceId);
}

export async function loadAutomationForEdit(bot) {
    if (bot.sourceType !== 'automation') return null;
    return getAutomation(bot.sourceId);
}

export async function createAlgoBot(payload) {
    const response = await axios.post(`${BOTS_URL}algo`, payload);
    return response.data;
}

export async function getBotPerformance(sourceType, sourceId) {
    const response = await axios.get(`${BOTS_URL}${sourceType}/${sourceId}/performance`);
    return response.data;
}